import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import { db } from "@/firebase/firebaseConfig.js";

import FireStoreService from "@/services/fireStoreService";

const portMasterBerthMasterApi = AiseaApiFactory.get("portMasterBerthMaster");
const portMasterEnterpriseAgencyMasterApi = AiseaApiFactory.get(
  "portMasterEnterpriseAgencyMaster",
);
const portMasterAgencyMasterApi = AiseaApiFactory.get("portMasterAgencyMaster");
const portMasterPilotMasterApi = AiseaApiFactory.get("portMasterPilotMaster");
const portMasterTeamLeaderMasterApi = AiseaApiFactory.get(
  "portMasterTeamLeaderMaster",
);
const portMasterTugBoatMasterApi = AiseaApiFactory.get(
  "portMasterTugBoatMaster",
);
const portMasterVehicleMasterApi = AiseaApiFactory.get(
  "portMasterVehicleMaster",
);
const portMasterRopePickingBoatMasterApi = AiseaApiFactory.get(
  "portMasterRopePickingBoatMaster",
);
const portMasterTagMasterApi = AiseaApiFactory.get("portMasterTagMaster");
const portMasterWharfApi = AiseaApiFactory.get("portMasterPortWharf");
const portMasterColorApi = AiseaApiFactory.get("portMasterPortColor");
const portMasterTasksApi = AiseaApiFactory.get("portMasterTasks");
const gkmgPortMasterDailyReportsApi = AiseaApiFactory.get(
  "gkmgPortMasterDailyReports",
);

export default {
  async getGkmgPortMasterAuth({ commit }) {
    const accountInfo = await FireStoreService.getGkmgPortMasterAuth();
    if (!accountInfo.exists) {
      commit("SET_GKMG_PORT_MASTER_AUTH", {}); // 設定がない場合は空オブジェクトをセット
    } else {
      commit("SET_GKMG_PORT_MASTER_AUTH", accountInfo.data());
    }
  },

  async setStoredMasterSearchCondition({ commit }, payload) {
    commit("SET_STORED_MASTER_SEARCH_CONDITION", payload);
  },

  // 水先案内人API
  async fetchPilots(_, payload) {
    let res = await portMasterPilotMasterApi.fetch(payload);
    return res.data;
  },
  async deletePilot(_, payload) {
    let res = await portMasterPilotMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertPilot(_, payload) {
    await portMasterPilotMasterApi
      .add(payload.portId, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updatePilot(_, payload) {
    await portMasterPilotMasterApi
      .update(payload.portId, payload.id, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updatePilotOrders(_, payload) {
    let res = await portMasterPilotMasterApi.updateOrders(
      payload.portId,
      payload.body,
    );
    return res.data;
  },

  // 班長API
  async fetchTeamLeaders(_, payload) {
    let res = await portMasterTeamLeaderMasterApi.fetch(payload);
    return res.data;
  },
  async deleteTeamLeader(_, payload) {
    let res = await portMasterTeamLeaderMasterApi.delete(
      payload.portId,
      payload.id,
    );
    return res.data;
  },
  async insertTeamLeader(_, payload) {
    await portMasterTeamLeaderMasterApi
      .add(payload.portId, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updateTeamLeader(_, payload) {
    await portMasterTeamLeaderMasterApi
      .update(payload.portId, payload.id, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updateTeamLeaderOrders(_, payload) {
    let res = await portMasterTeamLeaderMasterApi.updateOrders(
      payload.portId,
      payload.body,
    );
    return res.data;
  },

  // タグボートAPI
  async fetchTugBoats(_, payload) {
    let res = await portMasterTugBoatMasterApi.fetch(payload);
    return res.data;
  },
  async deleteTugBoat(_, payload) {
    let res = await portMasterTugBoatMasterApi.delete(
      payload.portId,
      payload.id,
    );
    return res.data;
  },
  async insertTugBoat(_, payload) {
    await portMasterTugBoatMasterApi
      .add(payload.portId, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updateTugBoat(_, payload) {
    await portMasterTugBoatMasterApi
      .update(payload.portId, payload.id, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updateTugBoatOrders(_, payload) {
    let res = await portMasterTugBoatMasterApi.updateOrders(
      payload.portId,
      payload.body,
    );
    return res.data;
  },

  // 車両API
  async fetchVehicles(_, payload) {
    let res = await portMasterVehicleMasterApi.fetch(payload);
    return res.data;
  },
  async deleteVehicle(_, payload) {
    let res = await portMasterVehicleMasterApi.delete(
      payload.portId,
      payload.id,
    );
    return res.data;
  },
  async insertVehicle(_, payload) {
    await portMasterVehicleMasterApi
      .add(payload.portId, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updateVehicle(_, payload) {
    await portMasterVehicleMasterApi
      .update(payload.portId, payload.id, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updateVehicleOrders(_, payload) {
    let res = await portMasterVehicleMasterApi.updateOrders(
      payload.portId,
      payload.body,
    );
    return res.data;
  },

  // 綱取りボートAPI
  async fetchRopePickingBoats(_, payload) {
    let res = await portMasterRopePickingBoatMasterApi.fetch(payload);
    return res.data;
  },
  async deleteRopePickingBoat(_, payload) {
    let res = await portMasterRopePickingBoatMasterApi.delete(
      payload.portId,
      payload.id,
    );
    return res.data;
  },
  async insertRopePickingBoat(_, payload) {
    await portMasterRopePickingBoatMasterApi
      .add(payload.portId, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updateRopePickingBoat(_, payload) {
    await portMasterRopePickingBoatMasterApi
      .update(payload.portId, payload.id, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updateRopePickingBoatOrders(_, payload) {
    let res = await portMasterRopePickingBoatMasterApi.updateOrders(
      payload.portId,
      payload.body,
    );
    return res.data;
  },

  // タグAPI
  async fetchTags(_, payload) {
    let res = await portMasterTagMasterApi.fetch(payload);
    return res.data;
  },
  async deleteTag(_, payload) {
    let res = await portMasterTagMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertTag(_, payload) {
    await portMasterTagMasterApi
      .add(payload.portId, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updateTag(_, payload) {
    await portMasterTagMasterApi
      .update(payload.portId, payload.id, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async updateTagOrders(_, payload) {
    let res = await portMasterTagMasterApi.updateOrders(
      payload.portId,
      payload.body,
    );
    return res.data;
  },

  // 船舶
  // async deleteVessel(_, payload) {
  //   // payload: firestoreのドキュメントID(gkmg_pm_vessels)
  //   const res = await db.collection("gkmg_pm_vessels").doc(payload).delete();
  //   return res;
  // },
  // async insertVessel(_, payload) {
  //   const res = await db.collection("gkmg_pm_vessels").doc().set(payload.data);
  //   return res;
  // },

  /*
   * payload {
   *   docId: firestoreのドキュメントId（gkmg_pm_vessels）
   *   data: {
   *     編集項目1: 値1
   *        ・
   *        ・
   *     編集項目n: 値n
   *   }
   * }
   */
  async updateVessel(_, payload) {
    await db
      .collection("gkmg_pm_vessels")
      .doc(payload.docId)
      .set(payload.data, { merge: true });
  },

  /*
   * firestoreのgkmg_pm_vesselsから船舶情報を取得しstateに保存する。
   * stateに保存するvesselsDataObjは以下の形式
   * {
   *   id: 文字列（firestoreのドキュメントID)
   *   data: {} //diff.doc.data()
   * }
   *
   * diff.doc.data()は以下の形式
   * {
   *   ドキュメントid1 : {フィールド名１:値1, フィールド名2:値2,...,フィールド名n:値n }
   *   ドキュメントid2 : {フィールド名１:値1, フィールド名2:値2,...,フィールド名n:値n }
   *        .
   *        .
   *        .
   *   ドキュメントidn : {フィールド名１:値1, フィールド名2:値2,...,フィールド名n:値n }
   * }
   */
  searchVessels({ commit }) {
    // payload.displayItemsNumber 船舶管理画面一ページで表示する行数
    let subscribeObj = db
      .collection("gkmg_pm_vessels")
      .onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((diff) => {
          const vesselsDataObj = {
            id: diff.doc.id,
            data: diff.doc.data(),
            changeType: diff.type,
          };
          commit("SET_VESSELS_DATA", vesselsDataObj);
        });
      });
    commit("ADD_VESSELS_SUBSCRIBE_LIST", subscribeObj);
  },

  // firestoreのonSnapshotを解除する処理
  unsubscribeFirestoreOnVesselMaster({ commit, state }) {
    state.vesselsSubscribeList.forEach((unsubscribe) => {
      unsubscribe();
    });
    // vesselSubscribeListを[]に初期化
    commit("INIT_VESSELS_SUBSCRIBE_LIST");
    commit("RESET_VESSELS_DATA");
  },
  // バースAPI
  async fetchBerths(_, payload) {
    let res = await portMasterBerthMasterApi.fetch(payload.portId);
    return res.data;
  },
  async deleteBerth(_, payload) {
    let res = await portMasterBerthMasterApi.delete(payload.portId, payload.id);
    return res.data;
  },
  async insertBerth(_, payload) {
    await portMasterBerthMasterApi
      .add(payload.portId, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async fetchBerthDetail(_, payload) {
    let res = await portMasterBerthMasterApi.fetchDetail(
      payload.portId,
      payload.id,
    );
    return res.data;
  },
  async updateBerth(_, payload) {
    await portMasterBerthMasterApi
      .update(payload.portId, payload.id, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async searchBerths(_, payload) {
    let res = await portMasterBerthMasterApi.search(
      payload.portId,
      payload.query,
    );
    return res.data;
  },
  async updateBerthOrders(_, payload) {
    let res = await portMasterBerthMasterApi.updateOrders(
      payload.portId,
      payload.body,
    );
    return res.data;
  },

  // 代理店（法人）API
  async fetchEnterpriseAgencies() {
    let res = await portMasterEnterpriseAgencyMasterApi.fetch();
    return res.data;
  },
  async deleteEnterpriseAgency(_, payload) {
    let res = await portMasterEnterpriseAgencyMasterApi.delete(payload.id);
    return res.data;
  },
  async insertEnterpriseAgency(_, payload) {
    await portMasterEnterpriseAgencyMasterApi.add(payload.body).then((res) => {
      if (!res || !res.status) {
        throw res;
      } else {
        return res.data;
      }
    });
  },
  async fetchEnterpriseAgencyDetail(_, payload) {
    let res = await portMasterEnterpriseAgencyMasterApi.fetchDetail(payload.id);
    return res.data;
  },
  async updateEnterpriseAgency(_, payload) {
    await portMasterEnterpriseAgencyMasterApi
      .update(payload.id, payload.body)
      .then((res) => {
        if (!res || !res.status) {
          throw res;
        } else {
          return res.data;
        }
      });
  },
  async searchEnterpriseAgencies(_, payload) {
    let res = await portMasterEnterpriseAgencyMasterApi.search(payload.query);
    return res.data;
  },

  // 代理店API
  async fetchAgencies(_, payload) {
    let res = await portMasterAgencyMasterApi.fetch(payload);
    return res.data;
  },
  async deleteAgency(_, payload) {
    let res = await portMasterAgencyMasterApi.delete(
      payload.portId,
      payload.id,
    );
    return res.data;
  },
  async insertAgency(_, payload) {
    let res = await portMasterAgencyMasterApi.add(payload.portId, payload.body);
    return res.data;
  },
  async fetchAgencyDetail(_, payload) {
    let res = await portMasterAgencyMasterApi.fetchDetail(
      payload.portId,
      payload.id,
    );
    return res.data;
  },
  async updateAgency(_, payload) {
    let res = await portMasterAgencyMasterApi.update(
      payload.portId,
      payload.id,
      payload.body,
    );
    return res.data;
  },
  async updateAgencyOrders(_, payload) {
    let res = await portMasterAgencyMasterApi.updateOrders(
      payload.portId,
      payload.body,
    );
    return res.data;
  },

  async fetchColors({ commit }, payload) {
    let res = await portMasterColorApi.fetch(payload);
    commit("SET_COLORS", res.data);
    return res.data;
  },

  async fetchWharfs(_, payload) {
    let res = await portMasterWharfApi.fetch(payload);
    return res.data;
  },

  async exportTasks(_, payload) {
    let res = await portMasterTasksApi.export(payload.portId, payload.date);
    return res;
  },

  async downloadTasks(_, payload) {
    let res = await portMasterTasksApi.download(payload.portId, payload.date);
    return res;
  },

  async exportDailyReports(_, payload) {
    let res = await gkmgPortMasterDailyReportsApi.export(payload.date);
    return res;
  },
};
